// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Halogen_Aff_Util = require("../Halogen.Aff.Util/index.js");
var Halogen_Query = require("../Halogen.Query/index.js");
var Halogen_VDom_Driver = require("../Halogen.VDom.Driver/index.js");
var Ritoppu_Component_App = require("../Ritoppu.Component.App/index.js");
var Web_Event_EventTarget = require("../Web.Event.EventTarget/index.js");
var Web_HTML = require("../Web.HTML/index.js");
var Web_HTML_HTMLDocument = require("../Web.HTML.HTMLDocument/index.js");
var Web_HTML_Window = require("../Web.HTML.Window/index.js");
var Web_UIEvent_KeyboardEvent = require("../Web.UIEvent.KeyboardEvent/index.js");
var Web_UIEvent_KeyboardEvent_EventTypes = require("../Web.UIEvent.KeyboardEvent.EventTypes/index.js");
var on = function (eventType) {
    return function (document) {
        return function (fn) {
            return function __do() {
                var v = Web_Event_EventTarget.eventListener((function () {
                    var $8 = Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)((function () {
                        var $10 = Data_Functor["void"](Effect.functorEffect);
                        return function ($11) {
                            return $10(Effect_Aff.launchAff(fn($11)));
                        };
                    })());
                    return function ($9) {
                        return $8(Web_UIEvent_KeyboardEvent.fromEvent($9));
                    };
                })())();
                return Web_Event_EventTarget.addEventListener(eventType)(v)(false)(Web_HTML_HTMLDocument.toEventTarget(document))();
            };
        };
    };
};
var main = Halogen_Aff_Util.runHalogenAff(Control_Bind.bind(Effect_Aff.bindAff)(Halogen_Aff_Util.awaitBody)(function (v) {
    return Control_Bind.bind(Effect_Aff.bindAff)(Halogen_VDom_Driver.runUI(Ritoppu_Component_App.component)(Data_Unit.unit)(v))(function (v1) {
        return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_Window.document)(Web_HTML.window)))(function (v2) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(on(Web_UIEvent_KeyboardEvent_EventTypes.keydown)(v2)(function ($12) {
                return v1.query(Halogen_Query.tell(Ritoppu_Component_App.KeyboardDown.create($12)));
            })))(function () {
                return Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Unit.unit);
            });
        });
    });
}));
module.exports = {
    main: main,
    on: on
};
